import { apiUrl } from "../../../Constant/apiConstant"
import { postJsonRequest } from "../../../service/apiService"

export const resetPassword=async(tenant: string | undefined,payLoad:any)=>{
    try{
        const response= await postJsonRequest(apiUrl.UM_POST_RESET_PASSWORD,payLoad,tenant,false)

        if(response.status === 200){
            const {Status,Message}=response.data

            return {Status,Message}
        }
    }catch(error){
        console.log(error)
    }

    return null
}

export const getAccessToken=async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response =await postJsonRequest(apiUrl.ACM_POST_GET_TOKEN,payLoad,tenant,false)
        if(response.status === 200){
            const { Status, Message, AccessToken } = response.data

            return {Status:Status,Message:Message,AccessToken:AccessToken}
        }
    }catch(error){
        console.log(error)
    }
    return null
}

export const changePasword=async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.UM_POST_CHANGE_PASSWORD,payLoad,tenant,false)
        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false
}

export const validateSecretKey=async(tenant: string | undefined,payLoad:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.UM_POST_VALIDATE_SECRET_KEY,payLoad,tenant,false)
        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}